var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Component } from 'react';
import { View } from 'react-native';
import { IconComponent } from '../Icons/IconComponent';
import { component } from '../../Decorators/Component';
import { CoreConfig } from '../../../CoreConfig';
import { Configuration } from '../../../Domain/DTOs/Configuration/ConfigurationDTO';
import { AnimatedTextView } from '../Typography/AnimatedTextView';
import { AnimatedImageView } from '../Image/AnimatedImageView';
import { AnimatedPressable } from '../Buttons/AnimatedPressable';
let InlineStepProgressBarView = class InlineStepProgressBarView extends Component {
    constructor() {
        super(...arguments);
        this.handlePress = (step) => {
            return typeof this.props.onPress === 'function' && this.props.onPress(step);
        };
    }
    render() {
        var _a;
        const indexOfActiveStep = this.props.values.findIndex(x => x.id === this.props.model);
        const circleSize = 20;
        return (_jsx(View, { style: (_a = this.props.style) === null || _a === void 0 ? void 0 : _a.container, children: this.props.values.map((x, i) => {
                var _a, _b, _c, _d, _e, _f, _g, _h;
                const isActive = indexOfActiveStep >= i;
                return (_jsxs(AnimatedPressable, { testID: `button-${x.title}`, style: (_a = this.props.style) === null || _a === void 0 ? void 0 : _a.btn, onPress: () => this.handlePress(x), children: [!!x.icon && (_jsx(IconComponent, { name: x.icon, size: circleSize, color: isActive ? '#1155CC' : '#879AAF' })), !!x.image && (_jsx(AnimatedImageView, { image: x.image, containerStyle: { height: circleSize, width: circleSize } })), !x.icon && (_jsx(View, { style: [(_b = this.props.style) === null || _b === void 0 ? void 0 : _b.circle, isActive && ((_c = this.props.style) === null || _c === void 0 ? void 0 : _c.circleActive)], children: _jsx(AnimatedTextView, { textStyle: [(_d = this.props.style) === null || _d === void 0 ? void 0 : _d.circleText], children: i + 1 }) })), _jsx(AnimatedTextView, { textStyle: [(_e = this.props.style) === null || _e === void 0 ? void 0 : _e.text, isActive && ((_f = this.props.style) === null || _f === void 0 ? void 0 : _f.textActive)], children: x.title }), i + 1 < this.props.values.length && _jsx(View, { style: [(_g = this.props.style) === null || _g === void 0 ? void 0 : _g.line, indexOfActiveStep > i && ((_h = this.props.style) === null || _h === void 0 ? void 0 : _h.lineActive)] })] }));
            }) }));
    }
};
InlineStepProgressBarView = __decorate([
    component({
        provider: CoreConfig.provider,
        moduleName: CoreConfig.moduleName,
        componentName: Configuration.ComponentNames.inlineStepProgressBar,
        style: {
            container: {
                width: '100%',
                flexDirection: 'row',
                alignItems: 'center'
            },
            btn: {
                flexDirection: 'row',
                alignItems: 'center'
            },
            circle: {
                backgroundColor: '#879AAF',
                height: 20,
                width: 20,
                borderRadius: 20,
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'center'
            },
            text: {
                marginHorizontal: 8,
                fontSize: 12,
                lineHeight: 30,
                color: '#293B51'
            },
            circleActive: {
                backgroundColor: '#1155CC'
            },
            circleText: {
                color: '#fff',
                fontSize: 10,
                lineHeight: 12,
            },
            textActive: {
                color: '#1155CC'
            },
            lineActive: {
                backgroundColor: '#1155CC'
            },
            line: {
                height: 2,
                minWidth: 25,
                borderRadius: 4,
                backgroundColor: '#DBE2EB',
                marginEnd: 8
            }
        }
    })
], InlineStepProgressBarView);
export { InlineStepProgressBarView };
